import { HISTORY_TYPE, IHistoryStep, ILanding } from "src/modules/pe-landing-module/data/interfaces";
import { useLandingStore } from "src/modules/pe-landing-module/data/store";


export default function redo() {
    const currentLanding: ILanding      = useLandingStore.getState().currentLanding
    const history: IHistoryStep[]       = useLandingStore.getState().history
    const currentHistoryStep: number    = useLandingStore.getState().currentHistoryStep
    const step                          = history[ currentHistoryStep - 1]

    if(currentHistoryStep === 0 || !step) {
        return
    }
    
    console.log( currentHistoryStep, step, history )

    switch(step.type) {
            case HISTORY_TYPE.SECTION:
                if(!!step.data) {
                    const newLanding: ILanding = {
                        ...currentLanding,
                        sections: currentLanding.sections.map((section, i) => {
                            if( step.data.id === section.id ) {
                                return step.data;
                            }
                            return section;
                        })
                    }
                    
                    console.log( newLanding )
                    
                    useLandingStore.setState({ 
                        currentLanding: newLanding, 
                        currentHistoryStep: currentHistoryStep - 1 
                    })
                }
                break
            case HISTORY_TYPE.SETTINGS:
            default:
                return
        }
}